import { render, staticRenderFns } from "./shopDesc.vue?vue&type=template&id=3d2d8c5b&"
import script from "./shopDesc.vue?vue&type=script&lang=js&"
export * from "./shopDesc.vue?vue&type=script&lang=js&"
import style0 from "./shopDesc.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports